// import Activity from '../../../containers/DashboardContainers/activityContainer';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import Leaderboard from '../../../containers/DashboardContainers/leaderboardContainer';
import MyStats from '../../../containers/DashboardContainers/myStatsContainer';

class StatsLeaderboardDesktop extends React.Component {
  render() {
    return (
      <Row>
        <Col xs={6}>
          <Col xs={12} className="pb-3 pl-0">
            <MyStats />
          </Col>
          {/* <Col xs={12} className="pl-0">
            <Activity
              gradientId="gradientActyvityProgressBar"
              localStorageItem={this.props.localStorageItemActivity}
            />
          </Col> */}
        </Col>
        <Col xs={6} className="pl-1">
          <Leaderboard
            localStorageItem={this.props.localStorageItemLeaderboard}
          />
        </Col>
      </Row>
    );
  }
}

StatsLeaderboardDesktop.propTypes = {
  localStorageItemLeaderboard: PropTypes.string.isRequired,
  localStorageItemActivity: PropTypes.string.isRequired,
};
export default StatsLeaderboardDesktop;
